import { EEventSensorRemoteControlTabsType } from '@src/common/constant/enum';

const path = `/sensor-remote-control`;

export const sensorRemoteControlRouteMap: Record<EEventSensorRemoteControlTabsType, string> = {
  [EEventSensorRemoteControlTabsType.BLOCKED_EVENT]: `${path}/blocked-events`,
  [EEventSensorRemoteControlTabsType.BLOCKED_VIDEO_EVENT]: `${path}/blocked-video-events`,
  [EEventSensorRemoteControlTabsType.CCS_CONFIGURATION]: `${path}/css-configuration`,
  [EEventSensorRemoteControlTabsType.NETWORK_REQUEST_CONFIGURE]: `${path}/configured-network-request`,

  [EEventSensorRemoteControlTabsType.COLLECT_ATTRIBUTES]: `${path}/click-tracking/collect-attributes`,
  [EEventSensorRemoteControlTabsType.CSS_SELECTORS_DEFAULT]: `${path}/click-tracking/ccs-selectors-default`,
  [EEventSensorRemoteControlTabsType.CSS_SELECTORS_CUSTOM]: `${path}/click-tracking/ccs-selectors-custom`,
  [EEventSensorRemoteControlTabsType.CLICK_TRACKING]: `${path}/click-tracking`,
  [EEventSensorRemoteControlTabsType.SESSION_REPLAY]: `${path}/session-replay`,
  [EEventSensorRemoteControlTabsType.INTELLIGENT_COLLECTION]: `${path}/intelligent-collection`,
};
